    <template>
      <div class="dashboard">
          <div class="bulk-setup--mobile" v-responsive.md.sm.xs>
              <!--              -->
              <div  class="dashboard__table__header__bulk" style="position:relative; margin-right: 1em;">
                  <BaseButton @click.native="toggleBulkSetup" id="test-mobile-bulk-setup">
                      {{ $t('buttons.bulk') }}
                      <BaseIcon icon="chevron-down" />
                  </BaseButton>
                  <div v-if="selected.length === 0" class="overlay"></div>
              </div>
              <!--              -->
              <div  class="dashboard__table__header__bulk" style="position:relative">
                  <BaseButton v-if="selected.length <= 10" @click.native="goToBulkDetail" id="test-mobile-bulk-detail">
                      {{ $t('buttons.bulkdetail') }}
                      <BaseIcon icon="chevron-right" />
                  </BaseButton>
                      <div v-if="selected.length <= 1 || selected.length > 10" class="overlay"></div>
              </div>
          </div>
        <DashboardTabs/>
        <div class="dashboard__table--mobile" v-responsive.md.sm.xs>
            <CollapseHeight>
                <DashboardBulkSetup v-if="showBulkSetup && selected.length > 0" :sensors="paginatedUnits[0].sensors" :unitsID="selected" />
            </CollapseHeight>
            <DashboardListHeader :active-sort="sort" :sensors="type.sensors" @onSortChange="setSort">
                <template v-slot:checkbox>
                    <BaseCheckbox v-model="selectedAll" @input="selectAll" class="test-checkbox-all-items" />
                </template>
            </DashboardListHeader>
            <DashboardListRow
                    v-for="tentacle in orderedUnits"
                    :key="tentacle.id"
                    :tentacle="tentacle"
                    :sensors="type.sensors"
            >
                <template v-slot:checkbox>
                  <BaseCheckbox :val="tentacle.id" v-model="selected" class="test-checkbox-item"></BaseCheckbox>
                </template>
            </DashboardListRow>
            <transition name="fade">
                <div v-if="loading" class="loading-wrapper loading-wrapper--mobile">
                    <BaseSpinner text="info.loading_data" />
                </div>
            </transition>
            <div class="dashboard__list__footer" style="position: relative;border:none;">
                <div class="dashboard__list__footer__left">
                    Copyright © {{ new Date().getFullYear() }} Tentacles IoT B.V.<br>
                    <a
                            target="_blank"
                            href="https://stats.uptimerobot.com/460P5cA2M"
                            v-responsive.md.sm
                    >Server Status</a>
                    <span class="divider" v-responsive.md.sm></span>
                    <a href="https://tentaclesiot.com/privacypolicy/">{{ $t('privacy.title') }}</a>
                </div>
        </div>
        </div>
        <div class="dashboard__table" v-responsive.lg.xl>
          <div class="dashboard__table__header">
            <Search v-model="search" @clear="clearSearch" @onStopTyping="fetchData({search})" />
              <div style="display: inline-flex; margin: auto;">
              <transition name="fadeUp">
              <div v-if="(selected.length > 0 || showBulkSetup) && showInEnv(env_tentacles)" class="dashboard__table__header__bulk">
                <BaseButton @click.native="toggleBulkSetup" style="margin-right: 1em;">
                  {{ $t('buttons.bulk') }}
                  <BaseIcon icon="chevron-down" />
                </BaseButton>
              </div>
            </transition>
            <transition name="fadeUp">
              <div v-if="((selected.length > 1 && selected.length <= 10) || showBulkSetup) && showInEnv(env_tentacles)" class="dashboard__table__header__bulk">
                <BaseButton v-if="selected.length <= 10" @click.native="goToBulkDetail">
                  {{ $t('buttons.bulkdetail') }}
                  <BaseIcon icon="chevron-right" />
                </BaseButton>
              </div>
            </transition>
          </div>
            <Export :selected="selected" />
          </div>
          <CollapseHeight>
            <DashboardBulkSetup v-if="showBulkSetup && selected.length > 0" :sensors="paginatedUnits[0].sensors" :unitsID="selected" />
          </CollapseHeight>
          <DashboardListHeader :active-sort="sort" :sensors="type.sensors" @onSortChange="setSort">
            <template v-slot:checkbox>
              <BaseCheckbox v-model="selectedAll" @input="selectAll" class="test-checkbox-all-items" />
            </template>
          </DashboardListHeader>
          <div class="dashboard__list__content">
            <DashboardListRow
              v-for="(tentacle,index) in paginatedUnits"
              :key="tentacle.id"
              :tentacle="tentacle"
              :sensors="type.sensors"
            >
              <template v-slot:checkbox>
                <BaseCheckbox :val="tentacle.id" v-model="selected" class="test-checkbox-item" />
              </template>
            </DashboardListRow>
          </div>
          <div class="dashboard__list__footer">
            <div class="dashboard__list__footer__left">
              Copyright © {{ new Date().getFullYear() }} Tentacles IoT B.V.<br>
              <a
                target="_blank"
                href="https://stats.uptimerobot.com/460P5cA2M"
              >{{ $t('server_status.title') }}</a>
              <span class="divider"></span>
              <a href="https://tentaclesiot.com/privacypolicy/">{{ $t('privacy.title') }}</a>
            </div>
            <div class="dashboard__list__footer__right">
              <paginate
                v-model="actualPage"
                v-if="filtered_units.length > 10"
                :page-count="Math.ceil(filtered_units.length / 10)"
                :page-range="1"
                :prev-text="$t('buttons.previous')"
                :next-text="$t('buttons.next')"
                :container-class="'paginator'"
                :page-class="'paginator__item'"
              ></paginate>
            </div>
          </div>
          <transition name="fade">
            <div v-if="loading" class="loading-wrapper">
              <BaseSpinner text="info.loading_data" />
            </div>
          </transition>
        </div>
      </div>
    </template>
<script>
import { mapGetters } from 'vuex';
import Search from '@/components/Search.vue';
import Export from '@/components/Export.vue';
import DashboardListHeader from '@/views/dashboard/DashboardListHeader.vue';
import DashboardListRow from '@/views/dashboard/DashboardListRow.vue';
import DashboardBulkSetup from '@/views/dashboard/DashboardBulkSetup.vue';
import DashboardTabs from '@/views/dashboard/DashboardTabs.vue';
import CollapseHeight from '@/components/CollapseHeight.vue';

export default {
  name: 'Dashboard',
  components: {
    Search,
    Export,
    DashboardListHeader,
    DashboardListRow,
    DashboardBulkSetup,
    DashboardTabs,
    CollapseHeight,
  },
  data() {
    return {
      filtered_units: [],
      search: '',
      selectedAll: false,
      selectedAllIndex: [],
      selected: [],
      actualPage: 1,
      sort: {
        column: null,
        order: null,
      },
      showBulkSetup: false,
      globalKey: 1,
      env_emeta: process.env.VUE_APP_ENV_EMETA,
      env_tentacles: process.env.VUE_APP_ENV_TENTACLES,
      env_etentacles: process.env.VUE_APP_ENV_ETENTACLES,
    };
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.showBulkSetup = false;
      }
      if (this.units.length > 0 && this.units.length === newVal.length) {
        this.selectedAll = true;
      } else if (this.units.length === oldVal.length) {
        this.selectedAll = false;
      }
    },
    actualPage(newQuestion, oldQuestion) {
      if (this.selectedAllIndex[this.actualPage] === undefined) {
        this.selectedAll = false;
        return;
      }
      this.selectedAll = this.selectedAllIndex[this.actualPage]
    },
    units: {
      handler() {
        this.fetchData({ search: this.search });
      },
      immediate: true,
      deep: true,
    },
    $route(to, from) {
      this.selected = [];
      this.selectedAll = false;
      this.selectAll();
    },
  },
  computed: {
    ...mapGetters('tentacle', ['type', 'units', 'loading']),
    paginatedUnits() {
      return this.orderedUnits.slice((this.actualPage - 1) * 10, ((this.actualPage) * 10));
    },
    orderedUnits() {
      if (this.sort.column === null) {
        this.filtered_units.sort((a, b) => (a.favourite ? -1 : 1));
      }
      return this.filtered_units;
    },
    selectedQuery() {
      return this.selected.join();
    },
  },
  methods: {
    goToBulkDetail() {
      this.$router.push({ name: 'bulk-detail', query: { type: this.type.id, ids: this.selectedQuery } });
    },
    clearSearch() {
      this.search = '';
      this.fetchData({ search: this.search });
    },
    selectAll() {
      let i = 0;
      let isRemoved = false;
      if (this.selectedAll) {
        this.selectedAllIndex[this.actualPage] = true;
        this.selected = this.selected.concat(this.units.reduce((accumulator, tentacle) => {
          this.paginatedUnits.forEach((unit) => {
            if (unit.id === tentacle.id) {
              accumulator.push(tentacle.id);
            }
          });
          return accumulator;
        }, []));
      } else {
        this.selectedAllIndex[this.actualPage] = false;
        if (this.selected.length > 0) {
          while (i < this.selected.length) {
            this.paginatedUnits.forEach((tentacle) => {
              if (this.selected[i] === tentacle.id) {
                this.selected.splice(i, 1);
                isRemoved = true;
              }
            });
            if (!isRemoved) {
              i++;
            }
          }
        }
      }
    },
    fetchData(query) {
      this.filtered_units = this.$store.getters['tentacle/unitsByName'](query.search);
      this.filtered_units = this.filtered_units.map(unit => ({ ...unit }));
      this.globalKey += 1;
    },
    setSort(sort) {
      this.sort = sort;
      if (sort.column === 'unit') this.filtered_units = this.$store.getters['tentacle/unitsSortByString']({ key: 'name', type: sort.order });
      else if (sort.column === 'remark') this.filtered_units = this.$store.getters['tentacle/unitsSortByString']({ key: 'remark', type: sort.order });
      else if (sort.column === 'last-update') this.filtered_units = this.$store.getters['tentacle/unitsSortByDate']({ key: 'lastUpdate', type: sort.order });
      else {
        this.filtered_units = this.$store.getters['tentacle/unitsSortByValue']({
          key: sort.column,
          type: sort.order,
        });
      }
      this.fetchData({ search: this.search });
    },
    toggleBulkSetup() {
      this.showBulkSetup = !this.showBulkSetup;
    },
    showInEnv(type) {
      return process.env.VUE_APP_ENVIRONMENT === type;
    },
  },
};

</script>
    <style lang="scss" scoped>
    .dashboard {
      width: 94%;
      margin: 0 auto;

        .bulk-setup--mobile {
            display: inline-flex;
            margin: auto;
            width: 100%;
            @media only screen and (max-width: 543px) {
                margin-bottom: 2em;
            }
            .overlay {
                position: absolute;
                top: 0;
                left:0;
                height: 100%;
                width: 100%;
                background: rgba(255, 255, 255, 0.55);
                z-index: 4;
                border-radius: 0.5em;
            }
        }

      .dashboard__table--mobile {
          position: relative;
          background: white;
          border-radius: 0.5em;
          height: 100%;
          .dashboard__list__content {
              height: 5em;
              padding: 2.5em;
          }
      }
      &__title {
        height: 8rem;
        display: flex;
        align-items: center;
        font-size: 3rem;
        color: $dark;
        font-weight: 500;
        letter-spacing: -1px;
      }
      &__table {
        width: 100%;
        min-height: calc(100vh - 15rem);
        background-color: white;
        border-radius: 0.5rem 0.5rem 0 0;
        padding-bottom: 5rem;
        position: relative;
        box-shadow: 0 0 5px rgba(100, 116, 160, 0.1);
        &__header {
          height: 10rem;
          width: 100%;
          display: flex;
          align-items: center;
          border-bottom: 0.1rem solid $border-color;
          padding: 0 2rem;
          position: relative;
          z-index: 13;
          &__bulk {
            margin: 0 auto;
            transition: all 0.4s;
              @media only screen and (max-width: 991px) {
                  width:100%;
              }
            .btn {
              width: max-content;
                @media only screen and (max-width: 991px) {
                    width:100%;
                }
              .icon {
                width: 1.2rem;
              }
            }
          }
        }
      }
      &__list {
        &__content {
          width: 100%;
          height: 100%;
        }
        &__footer {
          width: 100%;
          height: 5.1rem;
          width: 100%;
          display: flex;
          align-items: center;
          padding: 0 1.5rem;
          font-weight: 500;
          position: absolute;
          bottom: 0;
          border-top: 0.1rem solid $border-color;
          &__left {
            font-size: 1.2rem;
            color: $grey;
            display: flex;
            align-items: center;
            span {
              color: darken($company-color, 15%);
            }

            a {
              color: $company-color;
              text-decoration: none;
              margin: 0 0.8rem;
              min-width: max-content;
            }

            .divider {
              display: inline-block;
              width: 1px;
              height: 20px;
              background: linear-gradient(to bottom, white 5%, #ddd, white 90%);
            }
          }

          &__right {
            margin-left: auto;
          }
        }
      }

      .loading-wrapper {
        position: absolute;
        top: 10rem;
        width: 100%;
        height: calc(100% - 10rem);
        background-color: rgba(255, 255, 255, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;

          &--mobile {
              top: 5rem;
              height: 100%;
          }
      }
    }
    </style>
